import React from 'react';
import { SERVICES } from '../data';

export default function WorkshopDetailScreen({ workshop, discount, onBack, onBook }) {
  if (!workshop) return null;

  const available = SERVICES.filter(s => workshop.services.includes(s.name));

  return (
    <div className="fade-up" style={{ padding:'20px 20px 100px', maxWidth:500, margin:'0 auto' }}>
      <button onClick={onBack} style={{
        background:'none', border:'none', color:'var(--grey-3)',
        fontSize:14, marginBottom:20, display:'flex', alignItems:'center', gap:6, cursor:'pointer',
      }}>
        ← Voltar
      </button>

      {/* Header */}
      <div style={{ textAlign:'center', marginBottom:28 }}>
        <div style={{ fontSize:56, marginBottom:12 }}>{workshop.icon}</div>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:22, fontWeight:700, color:'#fff', marginBottom:4 }}>
          {workshop.name}
        </h2>
        <p style={{ color:'var(--grey-4)', fontSize:14, marginBottom:12 }}>📍 {workshop.address}</p>
        <div style={{ display:'flex', gap:8, justifyContent:'center', flexWrap:'wrap' }}>
          <span className="badge badge-white">⭐ {workshop.rating} ({workshop.reviews})</span>
          <span className="badge badge-white">📏 {workshop.distance}</span>
          <span className="badge badge-orange">-{discount}% para você</span>
        </div>
      </div>

      {/* Services */}
      <h3 style={{ fontFamily:'var(--font-display)', fontWeight:700, fontSize:16, color:'#fff', marginBottom:14 }}>
        Serviços disponíveis
      </h3>
      <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
        {available.map(svc => {
          const discounted = Math.round(svc.basePrice * (1 - discount / 100));
          const saving     = svc.basePrice - discounted;
          return (
            <div
              key={svc.id}
              onClick={() => onBook(workshop, svc)}
              style={{
                background:'var(--surface)',
                border:'1px solid var(--border)',
                borderRadius:'var(--radius-md)',
                padding:16,
                display:'flex', alignItems:'center', gap:14,
                cursor:'pointer',
                transition:'var(--transition)',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = 'var(--orange)';
                e.currentTarget.style.background  = 'var(--orange-dim)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'var(--border)';
                e.currentTarget.style.background  = 'var(--surface)';
              }}
            >
              <div style={{ fontSize:28, flexShrink:0 }}>{svc.icon}</div>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, fontSize:14, color:'#fff', marginBottom:3 }}>{svc.name}</div>
                <div style={{ fontSize:12, color:'var(--grey-3)' }}>
                  Economia:{' '}
                  <span style={{ color:'var(--green)', fontWeight:600 }}>R$ {saving}</span>
                </div>
              </div>
              <div style={{ textAlign:'right', flexShrink:0 }}>
                <div style={{ fontSize:11, color:'var(--grey-4)', textDecoration:'line-through' }}>
                  R$ {svc.basePrice}
                </div>
                <div style={{ fontFamily:'var(--font-display)', fontSize:20, fontWeight:800, color:'var(--orange)' }}>
                  R$ {discounted}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Contact */}
      <div style={{
        marginTop:24,
        background:'var(--surface)', border:'1px solid var(--border)',
        borderRadius:'var(--radius-md)', padding:16,
      }}>
        <div style={{ fontWeight:600, color:'#fff', marginBottom:4, fontSize:14 }}>Contato</div>
        <div style={{ fontSize:13, color:'var(--grey-3)' }}>📞 {workshop.phone || '(11) 3000-0000'}</div>
      </div>
    </div>
  );
}
